/* RESPONSIBLE TEAM: team-inbox */
/* eslint-disable no-restricted-imports */
import { fragment } from 'ember-data-model-fragments/attributes';
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { buildValidations, validator } from 'ember-cp-validations';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class SummarizeConversation extends Step.extend(Validations) {
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.summarizeConversation;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'ai_assist_summarize_workflow';
  }

  static createNewStep(store: Store): SummarizeConversation {
    return store.createRecord('operator/visual-builder/step/summarize-conversation', {
      action: store.createFragment('rules/rule-action', {
        type: 'summarize-conversation',
        justAdded: true,
        actionData: {},
      }),
      type: 'operator/visual-builder/step/summarize-conversation',
    });
  }
}
